<template>
  <!-- New Chat -->
  <div class="modal fade" id="new-chat">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">New Chat</h5>
          <button type="button" class="close" data-bs-dismiss="modal" :aria-label="$t('close')">
            <span class="material-icons">close</span>
          </button>
        </div>

        <div class="modal-body">
          <form action="#">
            <div class="user-block-group mb-4">
              <div class="search_chat has-search">
                <span class="fas fa-search form-control-feedback"></span>
                <input
                  v-model="searchInput"
                  class="form-control chat_input"
                  id="search-contacted"
                  type="text"
                  placeholder="Code, email, username"
                />
              </div>

              <div class="sidebar sroll-side-view">
                <div v-for="(value, key) in filteredResults" :index="key">
                  <div v-if="contacts.length > 1" class="d-flex justify-content-between align-items-center ps-0 pe-0">
                    <div class="fav-title contact-title">
                      <h6 class="text-uppercase">{{ key }}</h6>
                    </div>
                  </div>

                  <ul class="user-list">
                    <li
                      v-for="contact in filteredResults[key]"
                      :key="contact.id"
                      class="user-list-item"
                      @click.prevent="selectedContactUsername = contact.username"
                    >
                      <div class="list-user-blk">
                        <UserAvatar :user="contact" online/>

                        <div class="users-list-body">
                          <div>
                            <h5>{{ contact.username }} (#{{contact.code}})</h5>
                            <p>{{ contact.email }}</p>
                            <p v-if="activeUsers.includes(contact.id)" class="text-success">Online</p>
                            <p v-else class="text-gray-600">Offline</p>
                          </div>
                        </div>

                        <div class="notify-check parti-notify-radio">
                          <div
                            class="form-check d-flex align-items-center justify-content-start ps-0"
                          >
                            <label class="group-type-radio">
                              <input :checked="selectedContactUsername === contact.username" type="radio" name="radio" />
                              <span class="checkmark"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="mute-chat-btn">
              <button
                id="btn-close-contacts"
                type="button"
                class="btn btn-secondary btn-block"
                data-bs-dismiss="modal"
                :aria-label="$t('close')"
                @click="dismissModal"
              >
                <i class="feather-x me-1"></i>Cancel
              </button>

              <button
                type="button"
                class="btn btn-primary btn-block"
                @click.prevent="startChat"
              >
                <img src="@/assets/img/icon/send.svg" class="me-1" alt="image" />Chat
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /New Chat -->
</template>

<script>
import {mapGetters} from "vuex";
import UserAvatar from "@/components/frontend/UserAvatar";

export default {
  components: {UserAvatar},
  props: {
    //
  },

  data() {
    return {
      selectedContactUsername: null,
      searchInput: '',
    };
  },

  computed: {
    ...mapGetters({
      contacts: 'chat/contacts',
      activeUsers: 'chat/activeUsers',
    }),

    filteredResults() {
      let results = {};
      let data = [...this.contacts];

      if (this.searchInput) {
        data = data.filter(el =>
          el.username.includes(this.searchInput)
          || el.code.toString() === this.searchInput
          || el.email.toString().includes(this.searchInput)
        )
      }

      data.forEach(e => {
        results[e.username[0].toLowerCase()] = results[e.username[0].toLowerCase()] ?? [];
        results[e.username[0].toLowerCase()].push(e);
      });

      return results;
    },
  },

  methods: {
    async startChat() {
      if (!this.selectedContactUsername) {
        return;
      }

      this.$eventHub.$emit('toggleChat', true);
      this.$eventHub.$emit('toggleMenu', false);

      const conversation = await this.$store.dispatch('chat/startConversation', {username: this.selectedContactUsername});

      if (this.$route.name === 'chat-conversation') {
        this.$eventHub.$emit('toggleChat', true);
        this.$eventHub.$emit('toggleMenu', false);
      } else {
        this.$router.push({name: 'chat-conversation', params: {id: this.selectedContactUsername}});
      }

      if (conversation && conversation.id !== 'new') {
        this.$store.dispatch('chat/markConversationAsRead', {conversation, messagesForUserId: conversation.user.id});
      }

      this.dismissModal();
      this.forceClose();
    },

    forceClose() {
      document.querySelector('#btn-close-contacts').click();
    },

    dismissModal() {
      this.searchInput = '';
      this.selectedContactUsername = null;
    },
  },
};
</script>

<style scoped>
</style>
